/**
 * Logger 유틸리티 함수들
 */

import type { Attributes } from './types';

/**
 * 속성 객체를 문자열 값으로 변환 (sanitize)
 *
 * HyperDX의 setGlobalAttributes는 Record<string, string>을 받습니다.
 * 다양한 타입의 값을 string으로 변환합니다.
 *
 * @param attrs - OTLP-호환 attribute 객체
 * @returns 모든 값이 string으로 변환된 객체. null/undefined는 제외됨
 */
export function sanitizeAttrs(attrs: Attributes): Record<string, string> {
  const result: Record<string, string> = {};
  for (const key in attrs) {
    if (Object.prototype.hasOwnProperty.call(attrs, key)) {
      const val = attrs[key];
      if (val != null) {
        result[key] = String(val);
      }
    }
  }
  return result;
}
